module.exports = __webpack_public_path__ + "img/logo-footer.59de8d3.svg";